import { render, staticRenderFns } from "./AdminWohnungNew.vue?vue&type=template&id=33b2f4d0&scoped=true&"
import script from "./AdminWohnungNew.vue?vue&type=script&lang=js&"
export * from "./AdminWohnungNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminWohnungNew.vue?vue&type=style&index=0&id=33b2f4d0&prod&lang=css&"
import style1 from "./AdminWohnungNew.vue?vue&type=style&index=1&id=33b2f4d0&prod&scoped=true&lang=css&"
import style2 from "./AdminWohnungNew.vue?vue&type=style&index=2&id=33b2f4d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2f4d0",
  null
  
)

export default component.exports